var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.containerStyling},[_c('span',{class:_vm.iconStyling},[_c('i',{staticClass:"bi",class:_vm.icon})]),_vm._v(" "),_c('span',{class:_vm.textStyling},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }